import React from 'react';

const NavAndTabs = ({ tabs, activeTab, onTabChange, tabClassName = "nav-and-tab", contentClassname = "nav-and-tab-content" }) => {
    return (
        <>
            <ul className={`nav nav-pills mb-3 ${tabClassName}`} id="pills-tab" role="tablist">
                {tabs?.map((tab, index) => (
                    <li className="nav-item" role="presentation" key={index}>
                        <button
                            className={`nav-link  ${activeTab === tab.id ? 'nav-active' : ''}`}
                            id={`pills-${tab.id}-tab`}
                            data-bs-toggle="pill"
                            data-bs-target={`#pills-${tab.id}`}
                            type="button"
                            role="tab"
                            aria-controls={`pills-${tab.id}`}
                            aria-selected={activeTab === tab.id}
                            onClick={() => onTabChange(tab.id)}
                            disabled={tab.disabled}
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>
            <div className={`tab-content ${contentClassname}`} id="pills-tabContent">
                {tabs?.map((tab, index) => (
                    <div
                        key={index}
                        className={`tab-pane fade ${activeTab === tab.id ? 'show active' : ''}`}
                        id={`pills-${tab.id}`}
                        role="tabpanel"
                        aria-labelledby={`pills-${tab.id}-tab`}
                        tabIndex="0"
                    >
                        {tab.content}
                    </div>
                ))}
            </div>
        </>
    )
}

export default NavAndTabs;
